import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-supplier-info-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, TranslateModule ],
  templateUrl: './supplier-info-modal.component.html',
  styleUrl: './supplier-info-modal.component.css'
})
export class SupplierInfoModalComponent {
  private translate = inject(TranslateService);
}
